import React from "react";
import { isEmpty } from "../../../../services/general.utils";
import { useTranslation } from "react-i18next";

const EmployeeLocationUpdatedInfo = ({ notification }) => {
  const { t } = useTranslation();

  const handleNotificationSubtitle = () => {
    return `"${notification.payload.removed_cities
      .map(city => city.name)
      .join(", ")}" ${
      notification.payload.removed_cities.length > 1 ? "have" : "has"
    } been removed from your locations. `;
  };

  return (
    <>
      <h4 className="notification-title">{t("location_change_title")}</h4>
      {!isEmpty(notification.payload.removed_cities) && (
        <p className="notification-subtitle">
          {handleNotificationSubtitle()}
          {t("location_change_sub_title")}
        </p>
      )}
      <p className="subtitle-description">{t("check_your_benefits_prefer")}</p>
    </>
  );
};

export default EmployeeLocationUpdatedInfo;
